import React from 'react';
import { Container } from 'reactstrap';

const Footer = props => {
  return (
    <Container fluid className='py-3 bg-primary text-white'>
      <Container>
        <p className='text-center'></p>
        <p className='text-center'>
          Handcrafted by &copy;
          <span className='font-weight-bold'> Neo Jay Andong</span>
        </p>
        <div className='d-flex justify-content-center'>
          {/* eslint-disable */}
          <a
            className='text-white mr-3'
            href='https://www.facebook.com/neojay.andong'>
            <i className='fab fa-facebook-f fa-fw'></i>
          </a>
          <a className='text-white mr-3' href='https://twitter.com/imneoj'>
            <i className='fab fa-twitter fa-fw'></i>
          </a>
          <a className='text-white' href='https://www.instagram.com/neeyojeey/'>
            <i className='fab fa-instagram fa-fw'></i>
          </a>
        </div>
      </Container>
    </Container>
  );
};

export default Footer;
